export enum WistiaVideoId {
  DASHBOARD_ANNOUNCEMENT_TEXT = '2m8t55pu7o',
  PRO_FEATURES = 'g3n7zvfdfa',
  PREMIUM_FEATURES = 'xpuuqea34o',
  ONBOARDING_SUCCESS = 'b9wjyus86q',
}
